export default __webpack_public_path__ + "static/media/provenance-cover.b1bc2f7a.png";